<template>
  <DefaultPage>
    <HomeHeroVideo/>
    <HomeLetter/>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import HomeHeroVideo from '@/components/home/HomeHeroVideo';
import HomeLetter from '@/components/home/HomeLetter';

export default {
  name: 'Home',
  components: {
    HomeLetter,
    HomeHeroVideo,
    DefaultPage
  }
};
</script>
